import { forwardRef } from "react";
import styles from "./TagLabel.module.css";

/**
 * Tag Label — Figma component set "Tag Label" (node 277:4548).
 * Variant axes: State (Default | Selected), Detail (suffix on/off), Icon (leading on/off).
 *
 * @param {boolean} [selected=false] Figma State=Selected (midnight + brand primary) vs Default (frosted white + midnight)
 * @param {boolean} [detail=false] show trailing detail line (e.g. date); pass `suffix` when true
 * @param {import('react').ReactNode} [icon] optional leading icon (e.g. plus)
 * @param {string} [suffix] trailing metadata shown when `detail` is true
 */
const TagLabel = forwardRef(function TagLabel(
  {
    label,
    selected = false,
    detail = false,
    suffix,
    icon,
    disabled = false,
    className,
    type = "button",
    ...rest
  },
  ref,
) {
  const showSuffix = Boolean(detail && suffix != null && suffix !== "");
  const hasIcon = Boolean(icon);
  const rootClass = [
    styles.root,
    selected ? styles.selected : styles.default,
    hasIcon && !detail && styles.iconTrailingPadding,
    className,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <button
      ref={ref}
      type={type}
      className={rootClass}
      disabled={disabled}
      aria-pressed={selected || undefined}
      {...rest}
    >
      {hasIcon ? <span className={styles.icon}>{icon}</span> : null}
      <span className={styles.label}>{label}</span>
      {showSuffix ? <span className={styles.detail}>{suffix}</span> : null}
    </button>
  );
});

export default TagLabel;
